"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

function _default(theme, _ref) {
  var multiline = _ref.multiline;
  return {
    root: {
      display: theme.display,
      position: 'relative',
      textAlign: 'left',
      color: theme.color,
      zoom: 1,
      width: theme.width,
      minWidth: theme.minWidth,
      maxWidth: multiline ? 'none' : '100%',
      '&:after': {
        clear: 'both',
        content: '""',
        display: 'block',
        height: 0
      }
    },
    field: {
      paddingRight: theme.paddingRight,
      paddingLeft: theme.paddingLeft,
      paddingTop: theme.paddingTop,
      paddingBottom: theme.paddingBottom,
      fontSize: theme.fontSize,
      lineHeight: theme.lineHeight,
      position: 'relative',
      color: theme.color,
      fontFamily: theme.fontFamily,
      fontWeight: theme.fontWeight,
      overflow: multiline ? 'auto' : 'hidden',
      textOverflow: multiline ? 'unset' : 'ellipsis',
      whiteSpace: multiline ? 'normal' : 'nowrap'
    },
    label: {
      color: theme.labelColor,
      fontSize: theme.labelFontSize,
      lineHeight: theme.labelLineHeight,
      textAlign: 'left',
      overflow: 'hidden',
      textWrap: 'none',
      whiteSpace: 'nowrap',
      wordWrap: 'normal',
      fontFamily: theme.fontFamily
    }
  };
}